/* 电子对账单 API */

import { httpPost } from '../assets/scripts/http';

/**
 * 获取电子对账单
 * @param {
 *  "IsAudited": true,
 *  "StatementDateStart": "2019-07-17T06:32:22.355Z",
 *  "StatementDateEnd": "2019-07-17T06:32:22.355Z",
 *  "StatementType": 1(供应商)， 2(采购商),
 *  "SupplierName": "string",
 *  "CustomerName": "string",
 *  "SSGUID": "00000000-0000-0000-0000-000000000000",
 *  "PageIndex": 0,
 *  "PageSize": 0
 * } data
 */
export function getStatement(data) {
  return httpPost('Statement/LoadPagtedStatement', data);
}

/**
 * 查询对账单明细
 * @param {
 *  "IsAudited": true,
 *  "StatementDateStart": "2019-07-17T06:32:22.362Z",
 *  "StatementDateEnd": "2019-07-17T06:32:22.362Z",
 *  "StatementType":1(供应商)， 2(采购商),
 *  "SupplierName": "string",
 *  "CustomerName": "string",
 *  "SSGUID": "00000000-0000-0000-0000-000000000000",
 *  "PageIndex": 0,
 *  "PageSize": 0
 *  } data
 */
export function getStatementDatails(data) {
  return httpPost('Statement/LoadStatement', data);
}

/**
 * 审核对账单
 * @param {
 *  "IsAudited": true,
 *  "StatementDateStart": "2019-07-17T06:32:22.358Z",
 *  "StatementDateEnd": "2019-07-17T06:32:22.358Z",
 *  "StatementType": 1(供应商)， 2(采购商),
 *  "SupplierName": "string",
 *  "CustomerName": "string",
 *  "SSGUID": "00000000-0000-0000-0000-000000000000",
 *  "PageIndex": 0,
 *  "PageSize": 0
 * } data
 */
export function auditStatement(data) {
  return httpPost('Statement/AuditStatement', data);
}
